<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;position: relative;">
        <template>
          <el-row>
            <el-button plain type="primary" @click="AddWhiteContacts">添加</el-button>
            <!-- <el-button :loading="loading" type="primary" @click="EditContacts">编辑</el-button> -->
          </el-row>
          <el-table v-loading="tableLoading"  :data="contactsInfo" style="margin-top: 10px;" height="410">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="primary" size="small"
                           @click.native.prevent="deleteRow(scope.$index, contactsInfo)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-button :loading="loading" type="success" @click="EditContacts">提交</el-button>
          </div>
        </template>
      </div>
    <AddWhiteContacts ref="AddWhiteContacts"  v-show="AddWhiteContactsShow" v-on:closeAddWhiteContactsShow="closeAddWhiteContactsShow" v-on:getData="getData"   ></AddWhiteContacts>
  </div>
</template>

<script>

import AddWhiteContacts from "./AddWhiteContacts";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "WhiteContacts",
  data() {
    return {
      AddWhiteContactsShow: false,
      tableLoading:false,
      userCode: '',
      contactsInfo: [],

    }
  },
  components: {
    AddWhiteContacts
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getWhiteContacts();
    },
    closeSelf() {
      this.$emit("closeWhiteContacts");
    },
    closeAddWhiteContactsShow(){
      this.AddWhiteContactsShow = !this.AddWhiteContactsShow;
    },
    deleteRow(index,rows){
      rows.splice(index, 1);
    },
    getData(contacts){
      this.contactsInfo.push(contacts);
    },
    AddWhiteContacts(){
      if(this.contactsInfo.length>14){
        this.$message({type: 'warning', message: '白名单联系人只能添加十五个!'});
      }else {
        this.$refs.AddWhiteContacts.init();
        this.AddWhiteContactsShow =!this.AddWhiteContactsShow;
      }
    },
    EditContacts(){
      if(this.contactsInfo.length===0){
        this.$message({type: 'warning', message: '请先添加白名单联系人！'});
      }else {
        this.$axios({
          method: 'post',
          url: this.$institutionUrl + "Positioning/EditWhiteContacts",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            userCode: this.userCode,
            phones:this.contactsInfo
          }
        }).then(
            (response) => {
              if (response.data.error === 0) {
                this.$message({type: 'success', message: '编辑成功'});
                this.$emit("closeWhiteContacts");
              } else if (response.data.error === 1) {
                this.$message({type: 'warning', message: response.data.message});
              }else {
                this.$message({type: 'warning', message: '编辑失败'});
              }
            }
        )
      }
    },
    getWhiteContacts(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/ListWhiteContacts",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.contactsInfo=response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
  }


}
</script>

<style lang="scss" scoped>

.footer{
  display: flex;
  justify-content: center;
  margin-top: 10px;
  .el-button{
    width: 180px;
  }
}

</style>